export const DEFAULTS = {
    API: {
        PAGE_SIZE: 10,
    },
};
